import { useState, useEffect } from 'react';
import axios from '../utilities/axios';
import * as API_END_POINT from '../utilities/constant';

const useProductData = (productId) => {
  const [productData, setProductData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isNotFound, setIsNotFound] = useState(false);

  useEffect(() => {
    const fetchProductData = async () => {
      try {
        setError(null);
        setIsNotFound(false);
        const res = await axios.get(API_END_POINT.STORE_PRODUCT_DETAILS(productId));
        setProductData(res.data.data);
      } catch (err) {
        setError(err);
        setIsNotFound(err?.response?.status === 404);
        console.error('Error fetching product details', err);
      } finally {
        setLoading(false);
      }
    };

    fetchProductData();
  }, [productId]);

  return { productData, loading, error, isNotFound };
};

export default useProductData;